export default "__VITE_ASSET__BcZQWRZF__"